<template>
  <!-- Modal -->
  <div class="modal fade" id="ThanksDemoQuestionnaireAlert" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content pb-3">
        <div class="modal-header py-2">
          <h5 class="modal-title" ><trans-text i18nKey="ui[94][101]" :isHtml="true"/></h5>
        </div>
        <div class="modal-body" style="padding-bottom:2rem;">
          <trans-text i18nKey="ui[94][102]" :isHtml="true"/>
        </div>

        <!-- フォーム送信UI -->
        <div class="row text-center">
          <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
            <div class="my-1">
              <button type="button" class="btn w-100 btn-lg btn-warning" @click="answer(1)" ><trans-text i18nKey="ui[94][103]" :isHtml="true"/></button>
            </div>
          </div>
        </div>

        <!-- フォーム送信UI -->
        <div class="row text-center">
          <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
            <div class="my-1">
              <button type="button" class="btn w-100 btn-lg btn-warning" @click="answer(0)" ><trans-text i18nKey="ui[94][104]" :isHtml="true"/></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import Order from 'processor/Order'
  export default {
    props:["input"],
    components: {
    },
    data () {
      return {
      }
    },
    created(){
    },
    methods:{
      answer(isDemoWantData){
        let order = store.session("order") || {}

        Order.updateQrderQuestionnaireAnswer(Object.assign({},this.input,{"order_id":order.id,"is_demo_want_data":isDemoWantData}))
          .then((res) => {
            if (res.status === "ng") {
              this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
              return
            }
            store.session("order",res.data.order)
            $("#ThanksDemoQuestionnaireAlert").modal("hide")

            if(isDemoWantData){
              this.$router.push({name:"payment::complete"})
                return
            }
            this.$router.push({name:"mypage::event::demo_questionnaire_orderer"})
          })

      }
    }

  }
  //
  //DIコンテナ作成

  //alert("test");

</script>

<style lang="scss" scoped>
  .modal-header{
    background-color: #fef7ea;
  }

  .modal-body{
    font-size: .9rem;
  }
</style>



// WEBPACK FOOTER //
// ThanksDemoQuestionnaireAlert.vue?96befc4e